import {connect} from 'react-redux';
import React, {Component} from 'react';
import {itemsFetchData} from "../actions/items";
import {showPeriod} from "../actions/filters";
import {fetchInactiveInverters} from '../actions/notifications';
import {arrayEqual} from "../util/util";

class Notifications extends Component{

    state = {
        notifications: [],
        loading: false,
    }

    componentWillMount = async () => {
        this.props.dispatch(showPeriod('today'));
        this.props.dispatch(itemsFetchData());
        this.props.dispatch(fetchInactiveInverters(this.props.todayInverters, true));

        this.setState({
            inactiveInverters: this.props.inactiveInverters ?
                this.props.inactiveInverters : []
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if(!arrayEqual(nextProps.inactiveInverters, this.state.inactiveInverters))
            this.setState({
                invertersYear: nextProps.invertersYear
            });
    }

    render = () => {
        let {inactiveInverters} = this.state;
        return(

            <div id='right-bar'>
                <div className='table'>
                    <div className='label'><span className='name'>Omvormers geen gegevens vandaag en gisteren</span></div>
                        {inactiveInverters.map((item,ndx) => {
                            return(
                                <div key={ndx} className={`notification ${item.color}`}>
                                    [{item.location_id}] {item.name} - Omvormer {item.id}
                                    <span className="time">{item.daysAgo.toString().replace('>', 'meer dan ')} {item.daysAgo !== 1 ? 'dagen' : 'dag'}</span>
                                </div>
                            );
                        })}
                </div>
            </div>
        );
    }
}


const mapStateToProps = ({items, notifications}) => {
    return {
        todayInverters: items.data || [],
        inactiveInverters: [...notifications.inactiveInverters]
    };
};

export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./src/components/Notifications.js